<template>
  <div class="animated fadeIn">
    <b-row style="padding: 10px;" v-if="selected">
      <b-col lg="8">
        <b-card header-tag="header" footer-tag="footer">
          <template #header>
            <span class="card-title" @click="openDetails(task)"
              >Task - {{ taskId }}</span
            >

            <span class="task-details" style="float:right; font-size:1em">
              <!-- History -->
              <i class="icon-info" style="color: #20a8d8;margin-right:5px"></i>
              <a style="font-size: 1.1em;" @click="showHistory()"> History </a>
              <!-- History -->

              <!-- Create date -->
              <i
                class="icon-calendar"
                style="color: #20a8d8; margin-right:5px; margin-left:15px"
              ></i>
              {{ selected.created_at.slice(0, 10) }}
              <!-- Create date -->

              <!-- Create time -->
              <i
                class="icon-clock"
                style="color: #20a8d8; margin-right:5px; margin-left:15px"
              ></i>
              {{ selected.created_at.slice(11, 16) }}
              <!-- Create time -->

              <!-- Status -->
              <i class="icon" :class="taskStatus.icon" />
              {{ taskStatus.text }}
              <!-- Status -->

              <!-- Edit -->
              <i
                class="icon-pencil"
                style="color: #20a8d8; margin-right:5px; margin-left:15px; cursor:pointer;"
                @click="(description = selected.desc), (editDescription = true)"
              />
              <!-- Edit -->

              <!-- Delete taks -->
              <i
                class="icon-trash"
                style="color: #20a8d8; margin-right:5px; margin-left:15px; cursor:pointer;"
                @click="$bvModal.show('delete-modal')"
              />
                <b-modal
                title="Delete Task"
                class="modal-primary"
                id="delete-modal"
                ok-title = "Yes"
                @ok="deleteTask()">
                  <span>Do you want to delete this Task?</span>
                </b-modal>
              <!-- Delete task -->
            </span>
          </template>
          <!-- Task description -->
          <b-card-text style="padding: 20px 0; font-size: 16px;">
            {{ parseText(selected.desc) }}
          </b-card-text>

          <b-card-text v-if="editDescription">
            <b-spinner
              style="height:39px; width:39px"
              type="grow"
              label="Loading..."
              v-if="updatingDesc"
            />
            <b-row v-else class="mt-5">
              <b-col lg="12">
                <textarea
                  style="width: 100%"
                  v-model="description"
                  rows="6"
                  placeholder="To-Do..."
                  class="text-area-description"
                />
              </b-col>
            </b-row>
            <div class="float-right mt-4" style="margin-right: 14px;">
              <b-row class="justify-between">
                <button
                  style="color: white"
                  class="btn btn-default"
                  @click="editDescription = false"
                >
                  Cancel
                </button>
                <button
                  class="btn btn-primary"
                  @click="
                    (updatingDesc = true),
                      (selected.desc = description),
                      updateItem()
                  "
                >
                  Save
                </button>
              </b-row>
            </div>
          </b-card-text>

          <template #footer>
            <b-row>
              <b-col lg="8" v-if="loadingUsers">
                <b-spinner
                  style="height:39px; width:39px"
                  type="grow"
                  label="Loading..."
                ></b-spinner>
              </b-col>
              <b-col lg="8" v-else>
                <div
                  style="display: inline-block;"
                  v-for="(assign, row) in selected.users"
                  v-bind:key="row"
                >
                  <b-row style="text-align:center">
                    <b-col lg="3">
                      <b-img
                        style="margin-right: 3px"
                        v-bind="image"
                        :alt="assign.name"
                        :src="assign.image"
                        rounded="circle"
                      >
                      </b-img>
                    </b-col>
                    <b-col lg="9">
                      <span style="text-align:left;display:block;">
                        {{ assign.name }}</span
                      >
                      <a
                        v-if="checkRemove(assign.badge)"
                        class="text-danger"
                        style="display:block;text-align:left;"
                        @click="removeUser(assign)"
                      >
                        Remove
                      </a>
                      <span
                        v-if="checkCreator(assign.badge)"
                        class="text-success"
                        style="display:block;text-align:left;"
                      >
                        Creator
                      </span>
                    </b-col>
                  </b-row>
                </div>
              </b-col>
            </b-row>
            <div v-if="selectedCategory === '0'">
              <hr />
              <b-row>
                <b-col lg="4">
                  Start Date:
                  <span style="color:#949494;">{{ selected.start_date }}</span>
                </b-col>
                <b-col lg="4">
                  End Date:
                  <span style="color:#949494;">{{ selected.end_date }}</span>
                </b-col>
              </b-row>
            </div>
          </template>
        </b-card>
      </b-col>
      <b-col lg="4">
        <b-card header-tag="header" footer-tag="footer">
          <template #header>
            <span style="font-size:1.1em">
              Actions
            </span>
          </template>

          <b-card-text>
            <b-row>
              <b-col lg="6">
                <label for="category">Category</label>
                <b-form-select
                  id="category"
                  v-model="selectedCategory"
                  :options="categories"
                  style="background-color: #515b65; color: white; border-color:#292929"
                  value-field="value"
                  text-field="label"
                  @change="updateItem"
                />
              </b-col>

              <b-col lg="6">
                <label for="priority">Priority</label>
                <b-form-select
                  id="priority"
                  v-model="selectedPriority"
                  :options="priorities"
                  style="background-color: #515b65; color: white; border-color:#292929"
                  value-field="value"
                  text-field="label"
                  @change="updateItem"
                />
              </b-col>
            </b-row>

            <b-row class="mt-2">
              <b-col lg="6">
                <label for="user">User</label>
                <b-form-select
                  id="user"
                  v-model="selectedUser"
                  :options="users"
                  style="background-color: #515b65; color: white; border-color:#292929"
                  value-field="badge"
                  text-field="name"
                  @change="addUser"
                />
              </b-col>
              <b-col lg="6" v-if="selectedCategory === '0'">
                <label for="user_on_task">User on task</label>
                <b-form-select
                  id="user_on_task"
                  v-model="selectedUserOnTask"
                  :options="itUsers"
                  style="background-color: #515b65; color: white; border-color:#292929"
                  value-field="badge"
                  text-field="name"
                  @change="updateItem"
                />
              </b-col>

              <b-col lg="6">
                <label for="status">Status</label>
                <b-form-select
                  id="status"
                  v-model="selectedStatus"
                  :options="statuses"
                  style="background-color: #515b65; color: white; border-color:#292929"
                  value-field="value"
                  text-field="label"
                  @change="updateItem"
                />
              </b-col>
            </b-row>
          </b-card-text>

          <template #footer>
            <b-row style="margin-bottom: 22px"> </b-row>
          </template>
        </b-card>
      </b-col>

      <b-col lg="6">
        <b-card style="margin: 5px; padding:10px 30px">
          <div
            style="text-align:center; font-size: 27px; font-weight:600; margin-bottom:15px"
          >
            Comments
          </div>
          <div>
            <span
              style="display:block; font-size:1.1em; background:rgb(47 53 58); margin:8px; padding:15px; border-radius:5px"
              v-for="comment in selected.comments"
              v-bind:key="comment.id"
            >
              <b>{{ comment.name }}</b>
              {{ parseText(comment.comment) }} <br />
              <em style="font-size:0.8em"> {{ comment.created_at }} </em></span
            >
            <b-form-textarea
              style="margin-top: 15px"
              id="textarea"
              v-model="comment"
              placeholder="Write comment ..."
            />

            <button
              @click="addComment()"
              type="button"
              :disabled="loadingComment"
              class="btn btn-primary btn-block"
              style="margin-top:10px"
            >
              <b-spinner
                style="height:18px; width:18px"
                v-if="loadingComment"
                type="grow"
                label="Loading..."
              ></b-spinner>
              <span v-else>Add Comment</span>
            </button>
          </div>
        </b-card>
      </b-col>
      <b-col lg="6">
        <b-card style="margin: 5px; padding:10px 30px">
          <div
            style="text-align:center; font-size: 27px; font-weight:600; margin-bottom:15px"
          >
            Attachments
          </div>
          <div>
            <b-card
              no-body
              class="overflow-hidden"
              v-for="file in selected.files"
              v-bind:key="file.id"
            >
              <b-row no-gutters>
                <b-col md="4">
                  <b-card-img
                    :src="file.comment"
                    alt="Image"
                    style="max-height: 100%; object-fit:contain;background-color:rgb(47, 53, 58);padding:10px"
                    class="rounded-0"
                    @click="showImage(file.comment)"
                    v-if="renderFile(file.comment) == 'image'"
                  ></b-card-img>
                  <b-card-img
                    src="/img/attachment.png"
                    alt="Image"
                    style="max-height: 100%; object-fit:contain;background-color:rgb(47, 53, 58);padding:10px"
                    class="rounded-0"
                    @click="goTo(file.comment)"
                    v-else
                  ></b-card-img>
                </b-col>
                <b-col md="8">
                  <b-card-body :title="file.file_name">
                    <b-card-sub-title class="mb-2">
                      {{ file.name }}
                    
                      <em class="float-right"
                        style="font-size:0.8em; display:inline-block; "
                      >
                        {{ file.created_at }}</em
                      >
                    </b-card-sub-title>
                    <b-card-text>
                      <a
                        target="_blank"
                        :href="file.comment"
                        style="font-size:0.9em"
                      >
                        <button
                          class="btn btn-primary "
                          style="margin-top:10px"
                        >
                          Click here to open
                        </button>
                      </a>
                    </b-card-text>
                  </b-card-body>
                </b-col>
              </b-row>
            </b-card>

            <b-form-file
              v-model="file"
              :state="Boolean(file)"
              style="margin-top:15px;backgrounD: #515b65"
              placeholder="Choose a file or drop it here..."
              drop-placeholder="Drop file here..."
            />

            <button
              @click="addFile()"
              type="button"
              :disabled="loadingFile"
              class="btn btn-primary btn-block"
              style="margin-top:10px"
            >
              <b-spinner
                style="height:18px; width:18px"
                v-if="loadingFile"
                type="grow"
                label="Loading..."
              ></b-spinner>
              <span v-else>Add File</span>
            </button>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <b-modal
      title="History"
      class="modal-primary"
      size="lg"
      centered
      v-model="modalHistory"
      @ok="modalHistory = false"
    >
      <b-table striped :items="history"></b-table>
    </b-modal>

    <b-modal
      title="Preview"
      class="modal-primary"
      size="xl"
      centered
      v-model="modalImage"
      @ok="modalImage = false"
    >
      <b-img :src="imagePreview" fluid alt="Fluid image"></b-img>
    </b-modal>
  </div>
</template>

<script>
import { format } from "date-fns";
import router from "../../router";
import { allowedPath } from "../../shared/utils";

export default {
  name: "TodoListDetail",
  computed: {
    taskStatus() {
      // 0 = TO-DO, 1 = In progress, 2 = Done, 3 = Archived
      if (this.selected.status === "0")
        return { text: "To-Do", icon: "fa fa-list" };
      if (this.selected.status === "1")
        return { text: "In Progress", icon: "fa fa-spinner" };
      if (this.selected.status === "2")
        return { text: "Done", icon: "fa fa-check-square-o" };
      if (this.selected.status === "3")
        return { text: "Archived", icon: "fa fa-hdd-o" };
    }
  },
  data: function() {
    return {
      selectedUserOnTask: "",
      itUsers: [],
      updatingDesc: false,
      selected: null,
      comment: null,
      file: null,
      taskId: null,
      loadingUsers: false,
      loadingComment: false,
      loadingFile: false,
      selectedUser: null,
      users: [],
      image: { blank: false, width: 40, height: 40, class: "" },
      modalHistory: false,
      history: null,
      modalImage: false,
      imagePreview: null,
      description: null,
      editDescription: false,
      selectedStatus: "",
      oldStatus: "",
      previousRoute: null,
      statuses: [
        {
          label: "To-Do",
          value: "0"
        },
        {
          label: "In Progress",
          value: "1"
        },
        {
          label: "Done",
          value: "2"
        },
        {
          label: "Archive",
          value: "3"
        }
      ],
      selectedCategory: null,

      categories: [
        {
          label: "Non IT",
          value: "1"
        },
        {
          label: "IT",
          value: "0"
        }
      ],
      selectedPriority: 1,
      priorities: [
        {
          label: "1",
          value: "1"
        },
        {
          label: "2",
          value: "2"
        },
        {
          label: "3",
          value: "3"
        },
        {
          label: "4",
          value: "4"
        },
        {
          label: "5",
          value: "5"
        },
        {
          label: "6",
          value: "6"
        },
        {
          label: "7",
          value: "7"
        },
        {
          label: "8",
          value: "8"
        },
        {
          label: "9",
          value: "9"
        },
        {
          label: "10",
          value: "10"
        }
      ]
    };
  },
  beforeRouteEnter(to, from, next) {
  next(vm => {
    vm.previousRoute = from
  })
},
  notifications: {
    toastSuccess: {
      // You can have any name you want instead of 'showLoginError'
      title: "Updated successfully",
      // message: 'Updates successfully',
      type: "success" // You also can use 'VueNotifications.types.error' instead of 'error'
    }
  },
  methods: {
    goTo(link) {
      window.location = link;
    },
    renderFile(url) {
      const extension = url
        .split(/[#?]/)[0]
        .split(".")
        .pop()
        .trim();
      if (
        extension === "jpg" ||
        extension === "JPG" ||
        extension === "JPEG" ||
        extension === "jpeg" ||
        extension === "png" ||
        extension === "PNG"
      ) {
        return "image";
      }
      return "text";
    },
    showHistory() {
      this.modalHistory = true;
    },
    showImage(image) {
      this.imagePreview = image;
      this.modalImage = true;
    },
    parseText(data) {
      return data.replace(/&quot;/g, '"').replace(/&amp;/g, "&");
    },
    checkRemove(user) {
      const myBadge = localStorage.getItem("fns_user");
      if (myBadge === this.selected.badge) {
        if (user === myBadge) {
          return false;
        }
        return true;
      } else {
        if (user === myBadge) {
          return true;
        } else {
          return false;
        }
      }
    },
    checkCreator(badge) {
      if (this.selected.badge == badge) {
        return true;
      }
      return false;
    },
    removeUser(user) {
      this.loadingUsers = true;
      const formData = new FormData();
      formData.append("id", user.id);
      formData.append("badge", user.badge);
      formData.append('taskId', this.selected.task_id)

      this.$http.post("api/fns/todoList/deleteUser.php", formData).then(
        res => {
          this.fetchData();
          this.comment = null;
        },
        err => {
          console.log(err);
        }
      );
      console.log(user);
    },
    addUser() {
      this.loadingUsers = true;
      const formData = new FormData();
      formData.append("user", this.selectedUser);
      formData.append("task", this.selected.task_id);

      this.$http.post("api/fns/todoList/addUser.php", formData).then(
        res => {
          this.fetchData();
          this.selectedUser = null;
        },
        err => {
          console.log(err);
        }
      );
      console.log(user);
    },
    addComment() {
      this.loadingComment = true;
      const formData = new FormData();
      formData.append("comment", this.comment);
      formData.append("task", this.selected.task_id);

      this.$http.post("api/fns/todoList/addComent.php", formData).then(
        res => {
          this.fetchData();
          this.comment = null;
        },
        err => {
          console.log(err);
        }
      );
    },
    addFile() {
      this.loadingFile = true;
      const formData = new FormData();
      formData.append("file", this.file);
      formData.append("task", this.selected.task_id);

      this.$http
        .post("api/fns/todoList/addFile.php", formData, {
          headers: { "Content-Type": "multipart/form-data" }
        })
        .then(
          res => {
            this.fetchData();
            this.file = null;
          },
          err => {
            console.log(err);
          }
        );
    },
    updateItem() {
      const formData = new FormData();
      const description = this.selected.desc.replace(/(&quot\;)/g, '"');

      // formData.append('status', this.selected.status === '3' ? '0' : '3');
      formData.append("id", this.selected.task_id);
      formData.append("desc", description);
      formData.append("status", this.selectedStatus);
      formData.append("priority", this.selectedPriority);
      formData.append("oldStatus", this.oldStatus);

      if (this.selectedCategory) {
        formData.append("category", this.selectedCategory);
      }

      if (this.selectedUserOnTask) {
        formData.append("user_on_task", this.selectedUserOnTask);
      }

      // if status is in progress update start date
      if (this.selectedStatus === "1") {
        const now = format(new Date(), "yyyy-MM-dd H:mm:ss");
        formData.append("start_date", now);
      }

      // if status is done update end date
      if (this.selectedStatus === "2" || this.selectedStatus === "3") {
        const now = format(new Date(), "yyyy-MM-dd H:mm:ss");
        formData.append("end_date", now);
      }

      this.$http.post("api/fns/todoList/updateItem.php", formData).then(
        () => {
          this.toastSuccess();
          this.fetchData();
          this.editDescription = false;
          this.updatingDesc = false;
        },
        err => {
          console.log(err);
        }
      );
    },

    fetchData() {
      this.$http.get("api/fns/todoList/getItem.php?task=" + this.taskId).then(
        res => {
          console.log("res tasks", res);
          this.selected = res.data[0];
          this.loadingUsers = false;
          this.loadingComment = false;
          this.loadingFile = false;
          this.selectedCategory = res.data[0].category;
          this.selectedPriority = res.data[0].priority;
          this.selectedStatus = res.data[0].status;
          this.selectedUserOnTask = res.data[0].user_on_task;
          this.oldStatus = res.data[0].status;
        },
        err => {
          this.loading = false;
          console.log(err);
        }
      );

      this.$http.get("api/fns/todoList/getHistory.php?id=" + this.taskId).then(
        res => {
          this.history = res.data;
        },
        err => {
          this.loading = false;
          console.log(err);
        }
      );

      this.$http.get("api/fns/todoList/portalUsers.php").then(
        res => {
          console.log("ress users", res);
          this.users = res.data;
          const itUsers = [];
          res.data.forEach(user => {
            if (
              user.badge === "1224" ||
              user.badge === "1211" ||
              user.badge === "1288" ||
              user.badge === "1295"
            ) {
              itUsers.push(user);
            }
          });
          this.itUsers = itUsers;
        },
        err => {
          this.loading = false;
          console.log(err);
        }
      );
    },
    deleteTask(){
      const formData = new FormData();
      formData.append("taskId", this.taskId);
      formData.append("employeeId", localStorage.getItem("fns_user"));

      this.$http.post("api/fns/todoList/delete.php", formData).then(
        () => {
          if(this.previousRoute)
          {
            router.push(this.previousRoute.fullPath);
          }
        },
        err => {
          alert(err.error);
        }
      );
    }
  },

  mounted() {
    allowedPath(
      router.currentRoute.path,
      localStorage.getItem("user_tabs"),
      localStorage.getItem("redirect_path")
    );
    this.taskId = this.$route.query.task;
    this.fetchData();
  }
};
</script>

<style>
.text-area-description {
  background: #515b65;
  color: #ffffff;
  padding: 6px;
}

.custom-file-input.is-invalid ~ .custom-file-label {
  border-color: #2b2b2b !important;
  background: #515b65 !important;
  color: #ffffff38 !important;
}

.custom-file-input ~ .custom-file-label {
  border-color: #2b2b2b !important;
  background: #515b65 !important;
  color: white !important;
}

.custom-file-input ~ .custom-file-label[data-browse]::after {
  display: none !important;
}

.card-img-right {
  width: 50%;
}

.icon {
  color: #20a8d8;
  margin-right: 5px;
  margin-left: 15px;
}

@media only screen and (max-width: 534px) {
  .task-details {
    float: left !important;
    margin-left: -14px !important;
  }

  .assign-user {
    /*float: left !important;*/
  }
}

.card-title {
  font-size: 18px;
  font-weight: bold;
}
</style>
